export default {
  formatNumberRu(value) {
    if (value === 0 && typeof value === "number") {
      return "";
    } else {
      return new Intl.NumberFormat("ru-RU").format(value);
    }
  },
};
